<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <side-bar logo="static/img/app-icons/icon-34.png" title="Admin Panel">
      <template slot-scope="props" slot="links">
        <sidebar-item :link="{name: 'Dashboard', icon: 'nc-icon nc-chart-pie-35', path: '/dashboard'}">
        </sidebar-item>
        <sidebar-item :link="{name: 'Penjualan', icon: 'nc-icon nc-cart-simple', path: '/penjualan'}">
        </sidebar-item>
        <sidebar-item :link="{name: 'Pembelian', icon: 'nc-icon nc-delivery-fast', path: '/pembelian'}">
        </sidebar-item>
        <sidebar-item :link="{name: 'Barang', icon: 'nc-icon nc-backpack', path: '/barang'}">
        </sidebar-item>
        <sidebar-item :link="{name: 'Stok', icon: 'nc-icon nc-cloud-upload-94'}">
          <!-- <sidebar-item :link="{name: 'Tambah Stok', path: '/stok/create', icon: ['fa', 'sign-in-alt']}"></sidebar-item> -->
          <sidebar-item :link="{name: 'Stok', path: '/stok', icon: ['fa', 'sign-out-alt']}"></sidebar-item>
          <sidebar-item :link="{name: 'Transaksi Stok', path: '/transaksi-stok', icon: ['fa', 'layer-group']}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Barang terlaris', icon: 'nc-icon nc-favourite-28', path: '/item-terlaris'}">
        </sidebar-item>
        <sidebar-item :link="{name: 'Laporan Penjualan', icon: 'nc-icon nc-paper-2', path: '/laporan'}">
        </sidebar-item>
        <sidebar-item :link="{name: 'Pengaturan', icon: 'nc-icon nc-settings-gear-64'}">
          <sidebar-item :link="{name: 'sablon', path: '/pengaturan/sablon', icon: ['fa', 'print']}"></sidebar-item>
          <sidebar-item :link="{name: 'Kategori', path: '/pengaturan/kategori', icon: ['fa', 'boxes']}"></sidebar-item>
          <sidebar-item :link="{name: 'Warna', path: '/pengaturan/warna', icon: ['fa', 'fill-drip']}"></sidebar-item>
          <sidebar-item :link="{name: 'Ukuran', path: '/pengaturan/ukuran', icon: ['fa', 'infinity']}"></sidebar-item>
          <sidebar-item :link="{name: 'Kategori Pelanggan', path: '/pengaturan/kategori-pelanggan', icon: ['fa', 'boxes']}"></sidebar-item>
          <sidebar-item :link="{name: 'Pelanggan', path: '/pengaturan/pelanggan', icon: ['fa', 'user-friends']}"></sidebar-item>
          <sidebar-item :link="{name: 'Supplier', path: '/pengaturan/supplier', icon: ['fa', 'parachute-box']}"></sidebar-item>
          <sidebar-item :link="{name: 'Pengguna', path: '/pengaturan/pengguna/owner', icon: ['fa', 'user-tie']}"></sidebar-item>
          <sidebar-item :link="{name: 'Web Config', path: '/pengaturan/web-config', icon: ['fa', 'cogs']}"></sidebar-item>
        </sidebar-item>
      </template>
      <mobile-menu></mobile-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar ref="topNavBar" v-on:clickNotification="readNotification" v-on:openAllNotification="openNotificationSideWindow" v-on:closeAllNotification="closeNotificationSideWindow"></top-navbar>
      <dashboard-content @click.native="toggleSidebar">
      </dashboard-content>
    </div>
    <side-notification ref="sideNotification" @click="readNotification"/>
  </div>
</template>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './Extra/MobileMenu.vue'
  import SideNotification from './Notifications/Side.vue'
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu,
      SideNotification
    },
    mounted () {
      if (typeof this.$route.query.notification_uuid !== 'undefined') {
        this.readNotification(this.$route.query.notification_uuid)
      }
      this.doCheckRole()
      if (this.$store.getters['account/firebaseMessaging'] !== null && this.$store.getters['account/firebaseMessaging'] !== undefined) {
        this.$store.getters['account/firebaseMessaging'].onMessage((message) => {
          this.$store.dispatch('notification/firebase', {
            title: message.data.title,
            message: message.data.body,
            link: this.generateUrlNotification(message.data.uuid, message.datatype),
            afterClick: () => {
              this.readNotification(message.data.notificationUuid)
              this.$router.push(this.generateUrlNotification(message.data.uuid, message.datatype))
            }
          })
        })
      }
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      doCheckRole (roles) {
        return this.$route.meta.requiredAllowedRole.filter(role => role === this.$store.getters['account/accountData'].roles[0].name)
      },
      openNotificationSideWindow () {
        this.$refs.sideNotification.open()
      },
      closeNotificationSideWindow () {
        this.$refs.sideNotification.close()
      },
      generateUrlNotification (id, type) {
        return '#/penjualan/' + id
      },
      readNotification (notificationUuid) {
        this.$http.patch(window.AppConfig.apiUrl + 'notification/' + notificationUuid, {isRead: 1}).then(() => {
          this.$refs.topNavBar.getNotificationList()
          this.$refs.sideNotification.setRead(notificationUuid)
        })
      }
    }
  }

</script>
<style lang="scss">
  .vue-notifyjs.notifications{
    .list-move {
      transition: transform 0.3s, opacity 0.4s;
    }
    .list-item {
      display: inline-block;
      margin-right: 10px;

    }
    .list-enter-active {
      transition: transform 0.2s ease-in, opacity 0.4s ease-in;
    }
    .list-leave-active {
      transition: transform 1s ease-out, opacity 0.4s ease-out;
    }

    .list-enter {
      opacity: 0;
      transform: scale(1.1);

    }
    .list-leave-to {
      opacity: 0;
      transform: scale(1.2, 0.7);
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/DashboardLayout.vue